import "UI/Template";
import "UI/Element";
import "GIS/Map/Control/Base";
import "../../Geometry";

/** @namespace GIS.Map.Control */
NS("GIS.Map.Control");

/**
 * @class
 * @extends GIS.Map.Control.Base
 */
GIS.Map.Control.LocateMe = Class(GIS.Map.Control.Base, /** @lends GIS.Map.Control.LocateMe.prototype */ {
    /**
     * @type {$.<HTMLElement>}
     */
    $control: null,
    template: "GIS/Control/LocateMe",
    /**
     * @inheritDoc
     */
    initialize() {
        this.ParentCall();
        this.render();
    },
    /**
     * @returns {GIS.Map.Control.LocateMe}
     */
    render() {
        this.$control = UI.Template.$render(this.template, {
            control: this
        });
        this.$control.appendTo(this.target || this.map.element);

        UI.Element.initEvent("click", "on-click", this.$control, this);

        return this;
    },
    /**
     * @protected
     */
    onLocateMeClick() {
        if (this.map.geoloc) {
            const coordinate = this.map.getMap().getCurrentPosition()

            if (_.isEmpty(coordinate)) {
                alert('Координаты местоположения не доступны')
                return
            }

            this.map.setCenter(coordinate, 16);
        }
    }
});
